import React, { FC, useContext } from 'react';
import { Connect, PropsFromRedux } from './NavMarketingContainer';
import { USER_CURRENT_STATUS } from '../../../shared/constants/userStatusConstants';
import { NavCustomerButton } from './customers/NavCustomerButton';
import { NavToDoctrine } from './NavToDoctrine';
import { NavPublicPricing } from './pricing/NavPublicPricing';
import { UserContext } from '../user/UserContext';
import { NavPrivatePricing } from './pricing-button/NavPrivatePricing';

type Props = PropsFromRedux;

const RawNavMarketing: FC<Props> = ({ displayNavMarketing }) => {
  const { currentUser } = useContext(UserContext);

  if (!displayNavMarketing) return null;

  return (
    <div className="nav" data-test-id="nav-marketing">
      {currentUser.status === USER_CURRENT_STATUS.PRO_PLAN ? (
        <NavPublicPricing />
      ) : (
        <NavPrivatePricing />
      )}
      <NavCustomerButton />
      <NavToDoctrine />
    </div>
  );
};

export const NavMarketing = Connect(RawNavMarketing);
